export default __webpack_public_path__ + "static/media/fam.8bb1f403.jpg";